<template lang="pug">
#PageResultVehicles
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Vehicles" :HeaderGlobalBreadcrumb="breadcrumb")
    
    //- .wrapper.wrapper--sidebar
        aside.wrapper--sidebar__sidebar
            //- .sidebar-inner
                .sidebar-inner__header.p-3
                    .subheader
                        .list.flex.items-center.justify-between.mb-2
                            span No. Plat
                            strong.monospace AB1234XZY
                        .list.flex.items-center.justify-between.mb-2
                            span NIK
                            strong.monospace -
                        .list.flex.items-center.justify-between.mb-2
                            span KTP
                            strong.monospace -

                        .flex.justify-end.mb-4.w-full
                            a.btn-primary-o.py-1.px-2.w-full.text-center save as target
            Sidebar(:isKey="isKey")
            //- Sidebar

        section.wrapper--sidebar__content
            //- Header Global
            HeaderGlobal(HeaderGlobalHeading="Vehicles")
    
    template(v-if="load_data_status_vehicles.status === 'loading'")
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Plat Nomor : 
                            span -
                    .header-cta
            .box__body.p-4
                .block.mb-4
                    Loading(show="true")

    template(v-else)
        template(v-if="isKey && Object.keys(vehicles).length > 0")
            template(v-if="vehicles_status === 'old'")
                .box
                    header.box__header.no-border.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Plat Nomor : 
                                span {{ vehicles.plate_number ? vehicles.plate_number : '-' }}
                        .header-cta

                    .box__body.p-4
                        .block.mb-4
                            .flex.flex-wrap.-mx-4   
                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light Pemilik
                                        //- h3.monospace {{ vehicles.pemilik ? vehicles.pemilik : '-' }}
                                        h3.monospace
                                            router-link.link-text(v-if="vehicles.pemilik && vehicles.pemilik.length" :to="'/search-by-name/'+ encryptName(vehicles.pemilik)" target="_blank")
                                                | {{ vehicles.pemilik }}
                                            template(v-else) -
                                    .block.mb-4
                                        span.text-light Alamat
                                        h3.monospace {{ vehicles.alamat ? vehicles.alamat : '-' }}
                                    .block.mb-4
                                        span.text-light Alamat 2
                                        h3.monospace {{ vehicles.alamat2 ? vehicles.alamat2 : '-' }}
                                    .block.mb-4
                                        span.text-light Kode Lokasi
                                        h3.monospace {{ vehicles.kode_lokasi ? vehicles.kode_lokasi : '-' }}
                                    .block.mb-4
                                        span.text-light No. KTP
                                        h3.monospace {{ vehicles.nik ? vehicles.nik : '-' }}
                                    .block.mb-4
                                        span.text-light No. KK
                                        h3.monospace {{ vehicles.no_kk ? vehicles.no_kk : '-' }}
                                    .block.mb-4
                                        span.text-light No. HP
                                        h3.monospace {{ vehicles.no_hp ? vehicles.no_hp : '-' }}
                                    .block.mb-4
                                        span.text-light Nopol Lama
                                        h3.monospace {{ vehicles.nopol_lama ? vehicles.nopol_lama : '-' }}
                                    .block.mb-4
                                        span.text-light Status Pemilik
                                        h3.monospace {{ vehicles.sts_pemilik ? vehicles.sts_pemilik : '-' }}

                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light Merk
                                        h3.monospace {{ vehicles.merk ? vehicles.merk : '-' }}
                                    .block.mb-4
                                        span.text-light Jenis Kendaraan
                                        h3.monospace {{ vehicles.jenis_kend ? vehicles.jenis_kend : '-' }}
                                    .block.mb-4
                                        span.text-light Golongan Kendaraan
                                        h3.monospace {{ vehicles.gol_kend ? vehicles.gol_kend : '-' }}
                                    .block.mb-4
                                        span.text-light Kode Jenis
                                        h3.monospace {{ vehicles.kode_jenis ? vehicles.kode_jenis : '-' }}
                                    .block.mb-4
                                        span.text-light Kode Golongan
                                        h3.monospace {{ vehicles.kode_golongan ? vehicles.kode_golongan : '-' }}
                                    .block.mb-4
                                        span.text-light Tipe
                                        h3.monospace {{ vehicles.type ? vehicles.type : '-' }}
                                    .block.mb-4
                                        span.text-light Model
                                        h3.monospace {{ vehicles.merk ? vehicles.merk : '-' }}
                                    .block.mb-4
                                        span.text-light Warna
                                        h3.monospace {{ vehicles.warna ? vehicles.warna : '-' }}
                                    .block.mb-4
                                        span.text-light BBM
                                        h3.monospace {{ vehicles.bbm ? vehicles.bbm : '-' }}

                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light No. Rangka
                                        h3.monospace {{ vehicles.no_rangka ? vehicles.no_rangka : '-' }}
                                    .block.mb-4
                                        span.text-light No. Mesin
                                        h3.monospace {{ vehicles.no_mesin ? vehicles.no_mesin : '-' }}
                                    .block.mb-4
                                        span.text-light Rakit
                                        h3.monospace {{ vehicles.rakit ? vehicles.rakit : '-' }}
                                    .block.mb-4
                                        span.text-light Silinder
                                        h3.monospace {{ vehicles.silinder ? vehicles.silinder : '-' }}
                                    .block.mb-4
                                        span.text-light TNKB
                                        h3.monospace {{ vehicles.tnkb ? vehicles.tnkb : '-' }}
                                    .block.mb-4
                                        span.text-light Jumlah AS
                                        h3.monospace {{ vehicles.jml_as ? vehicles.jml_as : '-' }}
                                    .block.mb-4
                                        span.text-light Jumlah Beban
                                        h3.monospace {{ vehicles.jml_beban ? vehicles.jml_beban : '-' }}
                                    .block.mb-4
                                        span.text-light No. Faktur
                                        h3.monospace {{ vehicles.no_faktur ? vehicles.no_faktur : '-' }}
                                    .block.mb-4
                                        span.text-light Tgl Faktur
                                        h3.monospace {{ vehicles.tgl_faktur ? vehicles.tgl_faktur : '-' }}

                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light No. BPKB
                                        h3.monospace {{ vehicles.no_bpkb ? vehicles.no_bpkb : '-' }}
                                    .block.mb-4
                                        span.text-light Tgl BPKB
                                        h3.monospace {{ vehicles.tgl_bpkb ? vehicles.tgl_bpkb : '-' }}
                                    .block.mb-4
                                        span.text-light Tgl STNK
                                        h3.monospace {{ vehicles.tgl_stnk ? vehicles.tgl_stnk : '-' }}
                                    .block.mb-4
                                        span.text-light Tgl Pajak
                                        h3.monospace {{ vehicles.tgl_pajak ? vehicles.tgl_pajak : '-' }}
                                    .block.mb-4
                                        span.text-light Tgl Daftar
                                        h3.monospace {{ vehicles.tgl_daftar ? vehicles.tgl_daftar : '-' }}
                                    .block.mb-4
                                        span.text-light Jenis Daftar
                                        h3.monospace {{ vehicles.jns_daftar ? vehicles.jns_daftar : '-' }}
                                    .block.mb-4
                                        span.text-light Kode SAMSAT
                                        h3.monospace {{ vehicles.kd_samsat ? vehicles.kd_samsat : '-' }}
                                    .block.mb-4
                                        span.text-light Kode POLDA
                                        h3.monospace {{ vehicles.kd_polda ? vehicles.kd_polda : '-' }}
                                    .block.mb-4
                                        span.text-light Tgl Mati YAD
                                        h3.monospace {{ vehicles.tgl_mati_yad ? vehicles.tgl_mati_yad : '-' }}
                                    .block.mb-4
                                        span.text-light SAMSAT Bayar
                                        h3.monospace {{ vehicles.samsat_bayar ? vehicles.samsat_bayar : '-' }}

            template(v-else)
                .box.w-full(v-for="(vehicle, index) in vehicles" :key="index")
                    header.box__header.no-border.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Plat Nomor : 
                                span {{ vehicle.NRKB ? vehicle.NRKB : '-' }}
                        .header-cta

                    .box__body.p-4
                        .block.mb-4
                            .flex.flex-wrap.-mx-4   
                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light Pemilik
                                        //- h3.monospace {{ vehicle.NamaPemilik ? vehicle.NamaPemilik : '-' }}
                                        h3.monospace
                                            router-link.link-text(v-if="vehicle.NamaPemilik && vehicle.NamaPemilik.length" :to="'/search-by-name/'+ encryptName(vehicle.NamaPemilik)" target="_blank")
                                                | {{ vehicle.NamaPemilik }}
                                            template(v-else) -
                                    .block.mb-4
                                        span.text-light Alamat
                                        h3.monospace {{ vehicle.Alamat ? vehicle.Alamat : '-' }}
                                    .block.mb-4
                                        span.text-light No. HP
                                        h3.monospace {{ vehicle.NOHP ? vehicle.NOHP : '-' }}
                                    .block.mb-4
                                        span.text-light Email
                                        h3.monospace {{ vehicle.Email ? vehicle.Email : '-' }}
                                    .block.mb-4
                                        span.text-light NIKTDP
                                        h3.monospace {{ vehicle.NIKTDP ? vehicle.NIKTDP : '-' }}
                                    .block.mb-4
                                        span.text-light Kab/Kota
                                        h3.monospace {{ vehicle.KabKota ? vehicle.KabKota : '-' }}

                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light Merk
                                        h3.monospace {{ vehicle.Merk ? vehicle.Merk : '-' }}
                                    .block.mb-4
                                        span.text-light Jenis Kendaraan
                                        h3.monospace {{ vehicle.JenisKendaraan ? vehicle.JenisKendaraan : '-' }}
                                    .block.mb-4
                                        span.text-light Model Kendaraan
                                        h3.monospace {{ vehicle.ModelKendaraan ? vehicle.ModelKendaraan : '-' }}
                                    .block.mb-4
                                        span.text-light Tipe
                                        h3.monospace {{ vehicle.Type ? vehicle.Type : '-' }}
                                    .block.mb-4
                                        span.text-light Warna
                                        h3.monospace {{ vehicle.Warna ? vehicle.Warna : '-' }}

                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light No. Rangka
                                        h3.monospace {{ vehicle.NoRangka ? vehicle.NoRangka : '-' }}
                                    .block.mb-4
                                        span.text-light No. Mesin
                                        h3.monospace {{ vehicle.NoMesin ? vehicle.NoMesin : '-' }}
                                    .block.mb-4
                                        span.text-light Kode TNKB
                                        h3.monospace {{ vehicle.KodeTNKB ? vehicle.KodeTNKB : '-' }}
                                    .block.mb-4
                                        span.text-light Kode Kab/Kota
                                        h3.monospace {{ vehicle.KodeKabKota ? vehicle.KodeKabKota : '-' }}
                                    .block.mb-4
                                        span.text-light Kode Provinsi
                                        h3.monospace {{ vehicle.KodeProvinsi ? vehicle.KodeProvinsi : '-' }}

                                .block.px-4(class="w-full lg:w-1/4")
                                    .block.mb-4
                                        span.text-light Tgl STNK
                                        h3.monospace {{ vehicle.TglSTNK ? vehicle.TglSTNK : '-' }}
                                    .block.mb-4
                                        span.text-light Tahun Pembuatan
                                        h3.monospace {{ vehicle.TahunPembuatan ? vehicle.TahunPembuatan : '-' }}
                                    .block.mb-4
                                        span.text-light Kode Jenis Kendaraan
                                        h3.monospace {{ vehicle.KodeJenisKendaraan ? vehicle.KodeJenisKendaraan : '-' }}
                                    .block.mb-4
                                        span.text-light Kode Model Kendaraan
                                        h3.monospace {{ vehicle.KodeModelKendaraan ? vehicle.KodeModelKendaraan : '-' }}
                                    .block.mb-4
                                        span.text-light Status
                                        h3.monospace {{ vehicle.STATUS ? vehicle.STATUS : '-' }}

        .box(v-else)
            //- .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Vehicles
            //- .box__body.p-4
                .block.mb-4
                    .flex.flex-wrap.-mx-4   
                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light Data Not Found
                                //- h3.monospace Data Not Found

            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Plat Nomor : 
                            span -
                    .header-cta

            .box__body.p-4(v-if="vehicles_status === 'old'")
                .block.mb-4
                    .flex.flex-wrap.-mx-4   
                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light Pemilik
                                h3.monospace -
                            .block.mb-4
                                span.text-light Alamat
                                h3.monospace -
                            .block.mb-4
                                span.text-light Alamat 2
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Lokasi
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. KTP
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. KK
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. HP
                                h3.monospace -
                            .block.mb-4
                                span.text-light Nopol Lama
                                h3.monospace -
                            .block.mb-4
                                span.text-light Status Pemilik
                                h3.monospace -

                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light Merk
                                h3.monospace -
                            .block.mb-4
                                span.text-light Jenis Kendaraan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Golongan Kendaraan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Jenis
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Golongan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tipe
                                h3.monospace -
                            .block.mb-4
                                span.text-light Model
                                h3.monospace -
                            .block.mb-4
                                span.text-light Warna
                                h3.monospace -
                            .block.mb-4
                                span.text-light BBM
                                h3.monospace -

                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light No. Rangka
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. Mesin
                                h3.monospace -
                            .block.mb-4
                                span.text-light Rakit
                                h3.monospace -
                            .block.mb-4
                                span.text-light Silinder
                                h3.monospace -
                            .block.mb-4
                                span.text-light TNKB
                                h3.monospace -
                            .block.mb-4
                                span.text-light Jumlah AS
                                h3.monospace -
                            .block.mb-4
                                span.text-light Jumlah Beban
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. Faktur
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl Faktur
                                h3.monospace -

                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light No. BPKB
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl BPKB
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl STNK
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl Pajak
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl Daftar
                                h3.monospace -
                            .block.mb-4
                                span.text-light Jenis Daftar
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode SAMSAT
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode POLDA
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl Mati YAD
                                h3.monospace -
                            .block.mb-4
                                span.text-light SAMSAT Bayar
                                h3.monospace -

            .box__body.p-4(v-else)
                .block.mb-4
                    .flex.flex-wrap.-mx-4   
                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light Pemilik
                                h3.monospace -
                            .block.mb-4
                                span.text-light Alamat
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. HP
                                h3.monospace -
                            .block.mb-4
                                span.text-light Email
                                h3.monospace -
                            .block.mb-4
                                span.text-light NIKTDP
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kab/Kota
                                h3.monospace -
                            .block.mb-4
                                span.text-light Status
                                h3.monospace -

                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light Merk
                                h3.monospace -
                            .block.mb-4
                                span.text-light Jenis Kendaraan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Model Kendaraan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tipe
                                h3.monospace -
                            .block.mb-4
                                span.text-light Warna
                                h3.monospace -


                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light No. Rangka
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. Mesin
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode TBKB
                                h3.monospace -


                        .block.px-4(class="w-full lg:w-1/4")
                            .block.mb-4
                                span.text-light Tgl STNK
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tahun Pembuatan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Jenis Kendaraan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Model Kendaraan
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Kab/Kota
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Provinsi
                                h3.monospace -

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import { mapState } from 'vuex';
import { encrypt,decrypt } from '@/util/crypto';
import Sidebar from '@/components/shell/sidebar/Sidebar.vue';
import Loading from '@/components/Loading.vue';

export default {
    name: 'result',
    components: {
        Sidebar,
        HeaderGlobal,
        Loading,
    },
    props: ['resultGlobalBreadcrumb'],
    data: function() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Vehicles',
                    url: '/result/vehicles',
                },
            ],
            // isKey is for development only
            // isKey: this.$route.params.key!==undefined ? true : false,
            // isKey: this.key!==undefined ? true : false,
            // key: this.$route.params.key,
        };
    },
    computed: {
        ...mapState([
            'load_data_status_vehicles',
            'vehicles',
            'vehicles_status',
        ]),
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            return this.key ? true : false;
        }
    },
    watch: {
        key() {},
        isKey() {},
    },
    methods: {
        encryptName(name) {
            return encrypt(name + '&&name');
        },
        getData() {
            if (this.isKey) {
                let decrypt_data = decrypt(this.key);
                decrypt_data = decrypt_data.split('&&');
                // console.log(decrypt_data);
                var key = decrypt_data[0];
                // var type = decrypt_data[1];
                this.$store.dispatch('getVehicles', [key]);
            }
        },

        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        }
    },
    mounted() {
        // console.log('================== in Vehicles.vue');
        // this.getData();
    },
}
</script>

<style lang="sass">
h2.subheading
    font-weight: 500
    color: #344d58
    font-size: 1rem
    span
        font-family: 'Inconsolata', monospace
        font-size: 1.125em
        font-weight: 700
        // margin-bottom: .05em


.breadcrumb
    a, span
    font-size: 13px

    a
        display: block
        padding: 0.5rem
        position: relative
        &:hover
            color: #2E9C46
        &:after
            content: '/'
            margin-left: 0.5rem
            opacity: 0.3
            color: #3d3d3d
    span
        opacity: 0.5

</style>
